<template>
    <v-content>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md4>
                    <v-card class="elevation-12">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Registrar usuario</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-form id="nativeForm" v-model="valid">
                                <v-text-field
                                    id="username"
                                    prepend-icon="person"
                                    name="username"
                                    label="Usuario"
                                    v-model="username"
                                    type="text"
                                    :rules="usernameRules"></v-text-field>
                                <v-text-field
                                        id="password"
                                        prepend-icon="lock"
                                        name="password"
                                        label="Contraseña"
                                        v-model="password"
                                        :rules="passwordRules"
                                        type="password"></v-text-field>
                                <v-text-field
                                        v-if="action === 'register'"
                                        id="password_confirmation"
                                        prepend-icon="lock"
                                        name="password_confirmation"
                                        label="Confirmar Contraseña"
                                        v-model="password_confirmation"
                                        :rules="passwordConfirmationRules"
                                        type="password"></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="submit" :disabled="!valid">Enviar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>
<script>
    export default {
        name: "auth-form",
        props: {
          action: ''
        },
        data () {
            return {
                valid: false,
                username: '',
                usernameRules: [
                    (v) => !!v || 'El nombre de usuario es requerido'
                ],
                password: '',
                passwordRules: [
                    (v) => !!v || 'La contraseña es requerida',
                    (v) => v.length >= 6 || 'La contraseña debe tener al menos 6 caracteres'
                ],
                password_confirmation: '',
                passwordConfirmationRules: [
                    (v) => !!v || 'La confirmacion de la contraseña es requerida',
                    (v) => v.length >= 6 || 'La confirmacion de la contraseña debe tener al menos 6 caracteres',
                    (v) => v == this.password || 'La confirmacion no coincide con la contraseña',
                ]
            }
        },
        methods: {
          submit ()  {
            this.$emit('process', {username: this.username, password: this.password});
          }
        }
    }
</script>
